import { useTheme, useMediaQuery } from "@mui/material";
import { breakpoints as BREAKPOINTS } from "../tokens";

const useAIDTMediaQuery = () => {
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down(BREAKPOINTS.xs)); // 390px 이하
  const isMiniTablet = useMediaQuery(theme.breakpoints.down(BREAKPOINTS.sm)); // 512px 이하
  const isTablet = useMediaQuery(theme.breakpoints.down(BREAKPOINTS.md)); // 768px 이하
  const isNotebook = useMediaQuery(theme.breakpoints.down(BREAKPOINTS.lg)); // 1024px 이하
  const isDesktop = useMediaQuery(theme.breakpoints.up(BREAKPOINTS.lg + 1)); // 1025px 이상

  const isHeightSmall = useMediaQuery(`(max-height: ${BREAKPOINTS.height}px)`);

  return { isMobile, isMiniTablet, isTablet, isNotebook, isDesktop, isHeightSmall };
};

export default useAIDTMediaQuery;
